import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultipleNotificationConfigSelectComponent } from './multiple-notification-config-select.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [MultipleNotificationConfigSelectComponent],
  exports: [MultipleNotificationConfigSelectComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
  ],
})
export class MultipleNotificationConfigSelectModule {}
